import SellerOutboundReturnsApiV2 from 'api/v2/admins/seller-outbound-returns-api-v2'
import TitlePage from 'components/atoms/title-page'
import { ALERT_TYPES } from 'constants/alert-constants'
import SellerOutboundReturnCreateForm from 'domains/seller-outbound-return/organisms/create-form'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, CardBody } from 'reactstrap'


const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const SellerOutboundReturnCreatePage = ({ pageUtils }) => {

  const handleSubmit = async (values, formikBag) => {

    await SellerOutboundReturnsApiV2.create(values)
      .then(() => {
        pageUtils.setAlertMsg('Consignor Return has been created.', ALERT_TYPES.SUCCESS)
        formikBag.resetForm()
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
        formikBag.setErrors(error.response.data.messages)
      })
  }

  return (
    <>
      <TitlePage mainTitle={ 'Consignor Return' } subTitle={ 'Create Page' } />

      <Card>
        <CardBody>
          <SellerOutboundReturnCreateForm handleSubmit={ handleSubmit } />
        </CardBody>
      </Card>
    </>
  )
}

SellerOutboundReturnCreatePage.propTypes = propTypes

export default SellerOutboundReturnCreatePage
